// @ts-ignore
import React from 'react';
// @ts-ignore
import { useIntl } from 'react-intl';
import {
    ArrowLeftOutlined,
    EditOutlined,
    EyeOutlined,
    FormOutlined,
    HomeFilled,
    HomeOutlined,
} from '@ant-design/icons';
import { Space, Tooltip } from 'antd';
import { useAppSelector } from '../../../main/hooks';
import { MODE } from '../IStoredSurvey';
import { Link } from 'react-router-dom';
import { getI18n } from '../../../utils/Utils';

type IActionIconDocumentTypeCellRendererProps = {
    view?: any;
    edit?: any;
    onBulkEdit?: any;
    accept?: any;
};
const ActionIconDocumentTypeCellRenderer: React.FunctionComponent<IActionIconDocumentTypeCellRendererProps> = (
    props
) => {
    const intl = useIntl();

    const surveyState = useAppSelector((state) => state.survey);

    const isViewMode = () => {
        return surveyState.survey.surveyMode === MODE.VIEW ? true : false;
    };

    const isOverViewMode = () => {
        return surveyState.survey.surveyMode === MODE.OVERVIEW ? true : false;
    };

    const isReadOnly = () => {
        return isViewMode() || isOverViewMode();
    };

    const viewChannel = () => {
        // @ts-ignore
        props.view(props.data);
    };

    const editChannel = () => {
        // @ts-ignore
        props.edit();
    };

    const bulkEdit = () => {
        // @ts-ignore
        props.onBulkEdit();
    };
    const accept = () => {
        // @ts-ignore
        props.accept();
    };

    const editDocumentTypes = intl.formatMessage({
        id: 'survey-eDocument-supplier-edit-document-tooltip',
        defaultMessage: 'Expert View',
    });

    const bulkEditDocumentTypes = intl.formatMessage({
        id: 'survey-eDocument-supplier-bulk-edit-document-tooltip',
        defaultMessage: 'Edit All',
    });

    const viewDocumentTypes = intl.formatMessage({
        id: 'survey-eDocument-supplier-view-document-tooltip',
        defaultMessage: 'View eDocument types',
    });
    const acceptDefaultTooltipTitle = intl.formatMessage({
        id: 'survey-eDocument-supplier-grid-acceptDefault-tooltip-title',
        defaultMessage: 'Accept',
    });
    const warningMessage = intl.formatMessage({
        id: 'survey-eDocument-supplier-defaultAccept-message',
        defaultMessage:
            'You have decided to accept the BMW default settings for Format and Channels of the Process Groups on the eDocument Types for the selected partner/s.',
    });

    return (
        <div style={{marginTop:"20px"}}>
            <span className={"mt15"} style={{ marginTop: '20px' }} >
                <span style={{ marginRight: '20px' }} hidden={isReadOnly()}>
                    <Tooltip title={bulkEditDocumentTypes}>
                        <FormOutlined onClick={bulkEdit} style={{ fontSize: '25px', cursor: 'pointer' }} />
                    </Tooltip>
                </span>
                <span style={{ marginRight: '20px' }} hidden={isReadOnly()}>
                    <Tooltip title={editDocumentTypes}>
                        <EditOutlined onClick={editChannel} style={{ fontSize: '25px', cursor: 'pointer' }} />
                    </Tooltip>
                </span>

                <span style={{ marginRight: '10px' }}>
                    <Tooltip title={viewDocumentTypes}>
                        <EyeOutlined onClick={viewChannel} style={{ fontSize: '25px' }} />
                    </Tooltip>
                </span>
            </span>
        </div>
    );
};
export default ActionIconDocumentTypeCellRenderer;
